"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROW_HEIGHT_WEB = void 0;
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const getterUtils_1 = require("../getterUtils");
const core_1 = require("@material-ui/core");
const NoAnimationRadio_1 = __importDefault(require("../NoAnimationRadio"));
const theme_1 = require("../../../../styles/theme");
const CommonWeb_1 = require("../../../../components/FormFields/CommonWeb");
exports.ROW_HEIGHT_WEB = 42;
const RowRendererWeb = (props) => {
    const { generalProps, state, setState, refresh, style } = props;
    const classes = useCustomStyles();
    const commonClasses = (0, CommonWeb_1.useStyles)();
    const multiSelect = generalProps === null || generalProps === void 0 ? void 0 : generalProps.multiSelect;
    const isOptionSelected = (option) => {
        return !!state.find(value => (0, getterUtils_1.areOptionsEqual)(value, option, generalProps === null || generalProps === void 0 ? void 0 : generalProps.pathToValue));
    };
    const onChange = (option) => {
        const newState = (() => {
            if (multiSelect) {
                const isChecked = isOptionSelected(option);
                if (!isChecked) {
                    return [...state, option];
                }
                else {
                    return state.filter(value => !(0, getterUtils_1.areOptionsEqual)(value, option, generalProps === null || generalProps === void 0 ? void 0 : generalProps.pathToValue));
                }
            }
            else {
                return [option];
            }
        })();
        refresh();
        setState(newState);
    };
    const option = props.row;
    if (option === undefined) {
        return (react_1.default.createElement(core_1.ListItem, null,
            react_1.default.createElement(core_1.Typography, null, "undefined")));
    }
    const control = multiSelect ? (react_1.default.createElement(core_1.Checkbox, { checked: isOptionSelected(option), onChange: () => onChange(option), color: "primary", className: classes.checkBox })) : (react_1.default.createElement(NoAnimationRadio_1.default, { checked: isOptionSelected(option), onClick: () => onChange(option), className: commonClasses.radioButton }));
    return (react_1.default.createElement(core_1.ListItem, { dense: true, className: classes.item, style: style },
        react_1.default.createElement(core_1.FormControlLabel, { className: classes.item, classes: { label: classes.label }, value: (0, getterUtils_1.getValue)(option, generalProps === null || generalProps === void 0 ? void 0 : generalProps.pathToValue), control: control, label: (0, getterUtils_1.getLabel)(option, generalProps === null || generalProps === void 0 ? void 0 : generalProps.pathToLabel) })));
};
const useCustomStyles = (0, core_1.makeStyles)(() => ({
    item: {
        padding: 0,
    },
    label: {
        lineHeight: 'normal',
        fontSize: 15,
        fontWeight: 400,
        color: theme_1.colors.black0,
        fontStyle: 'normal',
    },
    checkBox: {
        paddingRight: 10,
    },
}));
exports.default = RowRendererWeb;
//# sourceMappingURL=TGOptionModalRowRendererWeb.js.map